import type { FunctionComponent, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { useIsIntersecting } from '../../hooks/useIsIntersecting';

interface ObservedElementProps extends IntersectionObserverInit {
  onIntersect?: () => void;
  onIntersectChange?: (isIntersecting: boolean) => void;
}

export const ObservedElement: FunctionComponent<PropsWithChildren<ObservedElementProps>> = ({
  rootMargin,
  threshold,
  onIntersect = () => null,
  onIntersectChange = () => null,
  children,
}) => {
  const { setNode, isIntersecting } = useIsIntersecting({ rootMargin, threshold });

  useEffect(() => {
    onIntersectChange(isIntersecting);
    if (isIntersecting) {
      onIntersect();
    }
  }, [isIntersecting, onIntersect, onIntersectChange]);

  return <div ref={setNode}>{children}</div>;
};
